import { GridColumnMenuFilter, GridColumnMenuProps } from '@progress/kendo-react-grid';
import { ComponentType } from 'react';
import ContractedIcon from 'src/assets/icons/ContractedIcon';
import OfflineIcon from 'src/assets/icons/OfflineIcon';
import PictureAvailableIcon from 'src/assets/icons/PictureAvailableIcon';
import SpecialOrderIcon from 'src/assets/icons/SpecialOrderIcon';
import AttributeFilterUI, {
  AttributeFilterOption,
} from 'src/components/AttributeFilterUI';


const searchAttributeOptions: AttributeFilterOption[] = [
  {
    type: 'isContracted',
    label: 'Contracted Item',
    icon: <ContractedIcon />,
  },
  {
    type: 'isOfflineSupplierItem',
    label: 'Offline Supplier Item',
    icon: <OfflineIcon />,
  },
  {
    type: 'isSpecialOrder',
    label: (
      <span style={{ display: 'block', lineHeight: '1.3', whiteSpace: 'nowrap' }}>
        Special Order - Item may incur
        <br />
        additional shipping charges
      </span>
    ),
    icon: <SpecialOrderIcon />,
  },
  {
    type: 'isImageAvailable',
    label: 'Picture Available',
    icon: <PictureAvailableIcon />,
  },
];

export const SEARCH_ATTRIBUTE_TYPES = searchAttributeOptions.map((option) => option.type);

const SearchAttributesFilter: ComponentType<GridColumnMenuProps> = (columnMenuProps) => (
  <GridColumnMenuFilter
    {...columnMenuProps}
    expanded={true}
    hideSecondFilter
    filterUI={(filterUIProps) => (
      <AttributeFilterUI {...filterUIProps} attributeOptions={searchAttributeOptions} />
    )}
  />
);

export default SearchAttributesFilter;
